export default "__VITE_ASSET__Dpe8QC6u__"